import { h } from 'preact';

function PlayCircleIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || 24}
      height={props.size || 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={props.color || 'currentColor'}
      stroke-width={props.strokeWidth || 1}
      stroke-linecap="round"
      stroke-linejoin="round"
      className={props.className || 'feather feather-play-circle'}
    >
      <circle cx="12" cy="12" r="10" />
      <polygon points="10 8 16 12 10 16 10 8" />
    </svg>
  );
}

export default PlayCircleIcon